import * as React from "react";
import type { SVGProps } from "react";
const SvgGift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="url(#gift_svg__a)"
      fillRule="evenodd"
      d="M17.741 2.917c1.492-1.49 3.922-1.504 5.418-.009s1.482 3.927-.01 5.418c-.232.233-.52.429-.806.592h6.027a2.264 2.264 0 0 1 2.264 2.264v4.655A2.264 2.264 0 0 1 28.37 18.1h-.063v9.838a2.264 2.264 0 0 1-2.265 2.264H6.96a2.264 2.264 0 0 1-2.265-2.264V18.1h-.063a2.264 2.264 0 0 1-2.264-2.264v-4.655a2.264 2.264 0 0 1 2.264-2.264h5.34a3.8 3.8 0 0 1-.804-.592c-1.492-1.491-1.504-3.922-.01-5.418 1.496-1.495 3.927-1.482 5.418.01.363.363.637.858.836 1.277.214.45.407.955.573 1.436q.09.262.173.52.08-.255.17-.514c.165-.48.358-.986.573-1.437.201-.422.476-.917.841-1.283m-3.946 4.63a23 23 0 0 0-.332-1.047 12 12 0 0 0-.46-1.16 4 4 0 0 0-.21-.392 2 2 0 0 0-.076-.11q-.027-.036-.028-.035a1.17 1.17 0 0 0-1.646-.009 1.17 1.17 0 0 0 .01 1.646q-.002 0 .037.031.04.03.113.077.15.095.393.211c.326.156.728.312 1.157.46.356.122.715.233 1.042.328m1.605 4.038H5.034v3.85H15.4zm0 6.516H7.36v9.435H15.4zm2.667 9.435v-9.435h7.573v9.435zm0-12.102v-3.85h9.9v3.85zm.453-7.889c.328-.096.69-.208 1.047-.331.43-.148.833-.305 1.16-.46q.243-.118.392-.21a2 2 0 0 0 .11-.076q.04-.03.035-.028a1.17 1.17 0 0 0 .009-1.646 1.17 1.17 0 0 0-1.646.009q0-.002-.031.038-.03.039-.077.112-.095.149-.211.394c-.156.326-.312.728-.46 1.157-.122.356-.233.715-.328 1.041"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="gift_svg__a"
        x1={25.575}
        x2={12.625}
        y1={6.803}
        y2={27.907}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FAEAB3" />
        <stop offset={1} stopColor="#FCB242" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgGift;
